import React from 'react';

// Simple list to display users
export default function UserList({ users }) {
  if (!users || users.length === 0) return <div>No users yet.</div>;
  return (
    <ul>
      {users.map((u) => (
        <li key={u.id}>{u.name} — {u.email}</li>
      ))}
    </ul>
  );
}
